class RoutineMediaSelects extends window.BAO.CustomElement() {
  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    this.querySelectorAll('select').forEach(select => {
      // Modified listener for 'change' event
      select.addEventListener('change', () => {
        // Get selected value
        const selectedOption = select.options[select.selectedIndex]

        // Create values for Main Image
        const variantMainImageSrc = selectedOption.dataset.variantImageSrc
        if (variantMainImageSrc) {
          const variantMainImageSrc180 = variantMainImageSrc.replace('&width=800', '&width=180')
          const variantMainImageSrc360 = variantMainImageSrc.replace('&width=800', '&width=360')
          const variantMainImageSrc540 = variantMainImageSrc.replace('&width=800', '&width=540')
          const variantMainImageSrc720 = variantMainImageSrc.replace('&width=800', '&width=720')

          // Create a new image element
          const mainSectionImageHTML = `<img src="${variantMainImageSrc}" srcset="${variantMainImageSrc180} 180w, ${variantMainImageSrc360} 360w, ${variantMainImageSrc540} 540w, ${variantMainImageSrc720} 720w" width="800" height="800" loading="lazy" class="rsp-Image_Image" sizes="(max-width: 767px) 100vw, (min-width: 768px) calc(100vw / 3)">`

          // Find closest section media image
          const closestSectionMainImage = select.closest('.sec-TabContent_Body').querySelector('.sec-TabContent_Image').querySelector('.rsp-Image')

          // Replace previous Main image with new one
          if (closestSectionMainImage) {
            closestSectionMainImage.innerHTML = mainSectionImageHTML
          }
        }

        // Create values for Selected Variant Image
        const variantProductImageSrc = selectedOption.dataset.variantProductImageSrc
        if (variantProductImageSrc) {
          const variantProductImageSrc180 = selectedOption.dataset.variantProductImageSrc.replace('&width=800', '&width=180')
          const variantProductImageSrc360 = selectedOption.dataset.variantProductImageSrc.replace('&width=800', '&width=360')
          const variantProductImageSrc540 = selectedOption.dataset.variantProductImageSrc.replace('&width=800', '&width=540')
          const variantProductImageSrc720 = selectedOption.dataset.variantProductImageSrc.replace('&width=800', '&width=720')

          // Create a new image element
          const variantProductImageHTML = `<img src="${variantProductImageSrc}" srcset="${variantProductImageSrc180} 180w, ${variantProductImageSrc360} 360w, ${variantProductImageSrc540} 540w, ${variantProductImageSrc720} 720w" width="800" height="800" loading="lazy" class="rsp-Image_Image" sizes="(max-width: 767px) 100vw, (min-width: 768px) calc(100vw / 3)">`

          // Find closest section media image
          const closestSectionVariantImage = select.closest('.sec-TabContent_Body').querySelector('.prd-CardSimple_Image').querySelector('.rsp-Image')

          // Replace previous Main image with new one
          if (closestSectionVariantImage) {
            closestSectionVariantImage.innerHTML = variantProductImageHTML
          }
        }
      })
    })
  }
}

if (!customElements.get('routine-media-select')) {
  customElements.define('routine-media-select', RoutineMediaSelects)
}
